import { trpc } from '@/main'
import type { RootSearch } from '@/routes/__root'

// The LIGHT loader-facing half of the applicant offers panel: the query input/options factories the
// offers route loader prefetches. Kept apart from applicant-offers-panel-content.tsx on purpose — route
// loaders load EAGERLY into the entry chunk, and importing these through the heavy panel used to drag the
// whole view (tree items, mini charts, sort/select chrome) into the entry bundle, inflating
// time-to-hydration on every page of the app. Same split as company-offers-query.ts.

/**
 * SINGLE SOURCE of the applicant `getOffersInfinite` input — used by the loader prefetch, the
 * `ApplicantOffersLayout` `hasOffers` read, AND the offers panel's list read, so all three share ONE cache
 * key. Previously the layout and loader hardcoded `{ q: '', o: 'added', type: 'competences' }` while the
 * panel derived `o`/`type` from search, so changing the sort or select-by spawned a SECOND cache entry
 * (double fetch + a `hasOffers` count computed from a different list than the one on screen, + a wasted
 * prefetch on a reload with a non-default `type`). `o` defaults to `'added'` and `type` to `'competences'`
 * (root schema), so on a cold load with no search params this equals the old hardcoded literal.
 */
export function applicantOffersInput(search: Pick<RootSearch, 'q' | 'o' | 'type'>) {
  return { q: search.q, o: search.o ?? 'added', type: search.type } as const
}

export function applicantOffersInfiniteQueryOptions(input: ReturnType<typeof applicantOffersInput>) {
  return trpc.applicants.getOffersInfinite.infiniteQueryOptions(input, {
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  })
}
